import { useTranslation } from 'react-i18next';
import { QueryKeys } from '@connect-x-app/shared-domain-models';
import { createQuickReply } from '@connect-x-app/web-data-access';
import { toastError, toastSuccess } from '@connect-x-app/web-ui';
import { useMutation, useQueryClient } from '@tanstack/react-query';

export const useCreateQuickReplies = () => {
  const queryClient = useQueryClient();

  const { t } = useTranslation();

  return useMutation({
    mutationFn: createQuickReply,
    mutationKey: [QueryKeys.QUICK_REPLIES],
    onError: () => {
      toastError(t('TOAST_ERROR'));
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [QueryKeys.QUICK_REPLIES] });
      toastSuccess(t('TOAST_SUCCESS'));
    },
  });
};
